// easyui-menubutton.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

// NB: Componente basato su EasyUI menubutton e adattato a Angular
// riferirsi a www.jeasyui.com/documentation/index#

import { Component, ElementRef, Input, ViewChild, ContentChildren, QueryList, AfterViewInit } from '@angular/core';
import { Globs } from '../globs';

declare let $: any;

@Component({
  selector: 'easyui-menubutton',
  template: `
  <div #host>{{title}}</div>
  <div id='{{id}}'>
    <ng-content></ng-content>
  </div>
`
})
export class EasyuiMenuButtonComponent implements AfterViewInit {
  id = Globs.uuidGen();
  private host: any;
  @Input() options: any = {};
  @Input() title: string;
  @Input() icon: string;
  @ViewChild('host') hostElement: ElementRef;
  @ContentChildren('menuitem') subItems: QueryList<any>;

  constructor() { }

  ngAfterViewInit() {
    this.configura(this.options);
  }

  public styleElement(tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  public findItem(name: string): any {
    let retVal = null;
    if (this.subItems.length) {
      this.subItems.forEach((elem) => {
        // let id = $(elem.nativeElement)
        const item = this.host.menu('getItem', $(elem.nativeElement)[0]);
        // console.log('Element', elem)
        // console.log('Native element', elem.nativeElement)
        // console.log('$Id', id)
        if (item.text === name) { retVal = item; }
      });
    }
    return retVal.target;
  }

  public getItem(target: any): any {
    return this.host.menu('getItem', $(target)[0]);
  }

  public appendItem(options: string) {
  }

  public removeItem(target: string) {
    this.host.menu('removeItem', $(target)[0]);
  }

  public toggleItemDisable(name: string) {
    const target = this.findItem(name);
    if ($(target).hasClass('menu-item-disabled')) {
      $(target).removeClass('menu-item-disabled');
    } else {
      $(target).addClass('menu-item-disabled');
    }
  }

  public enableItem(name: string) {
    const target = this.findItem(name);
    if (!$(target).hasClass('menu-item-disabled')) { return; }
    $(target).removeClass('menu-item-disabled');
  }

  public disableItem(name: string) {
    const target = this.findItem(name);
    if ($(target).hasClass('menu-item-disabled')) { return; }
    $(target).addClass('menu-item-disabled');
  }

  public toggleItemCheck(name: string) {
    const target = this.findItem(name);
    const icon = $(target).find('.glyphicon');
    if (icon.length) {
      this.setIcon(target, '');
    } else {
      this.setIcon(target, 'glyphicon glyphicon-ok');
    }
  }

  public checkItem(name: string) {
    const target = this.findItem(name);
    this.setIcon(target, 'glyphicon glyphicon-ok');
  }

  public uncheckItem(name: string) {
    const target = this.findItem(name);
    this.setIcon(target, '');
  }

  public isItemChecked(name: string): boolean {
    const target = this.findItem(name);
    const icon = $(target).find('.glyphicon');
    return (icon.length > 0);
  }

  public showItem(target: string) {
    this.host.menu('showItem', $(target)[0]);
  }

  public hideItem(target: string) {
    this.host.menu('hideItem', $(target)[0]);
  }

  public setText(target: string, text: string) {
    const item = this.getItem(target);
    this.host.menu('setText', {
      target: item.target,
      text
    });
  }

  public setIcon(target: string, icon: string) {
    const item = this.getItem(target);
    this.host.menu('setIcon', {
      target: item.target,
      iconCls: icon
    });
  }

  private configura(options: any) {
    this.host = $(this.hostElement.nativeElement);
    options.menu = '#' + this.id;
    if (this.icon) { options.iconCls = this.icon; }
    this.host.menubutton(options);
    // if (this.subItems.length) {
    //   this.subItems.forEach((elem) => {
    //     let id = $(elem.nativeElement)
    //     let item = this.host.menu('getItem',id[0])
    //     console.log(item.element)
    //     this.host.menu('disableItem',id)
    //     // console.log(elem)
    //   })
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-menubutton.component.ts